export const config = {
  GRAPHQL_URL: process.env.GRAPHQL_URL,
  SENTRY_DSN: process.env.SENTRY_DSN,
  SENTRY_RELEASE: process.env.SENTRY_RELEASE,
  FEEDBACK_ENV: process.env.FEEDBACK_ENV,
  COMMIT_SHA: process.env.COMMIT_SHA,
  GA_ID: process.env.GA_ID,
  PUBLIC_URL: process.env.PUBLIC_URL,
  NODE_ENV: process.env.NODE_ENV,
  FIREBASE_VAPID: process.env.FIREBASE_VAPID,
  FIREBASE_MESSAGING_SEND_ID: process.env.FIREBASE_MESSAGING_SEND_ID,
};
